function setNumeronostoWidths() {
    var containers = document.querySelectorAll('.numeronostot');

    containers.forEach(function (container) {
        var elements = container.querySelectorAll('.numeronosto');

        if (!elements.length) {
            return;
        }

        // Reset widths first so we always measure the natural width
        elements.forEach(function (element) {
            element.style.width = '';
        });

        // Only apply equal widths on screens 719px or smaller
        if (window.innerWidth > 719) {
            return;
        }

        var widest = 0;

        elements.forEach(function (element) {
            var width = element.getBoundingClientRect().width;

            if (width > widest) {
                widest = width;
            }
        });

        // Apply widest width to all elements
        elements.forEach(function (element) {
            element.style.width = widest + 'px';
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    setNumeronostoWidths();
});

window.addEventListener('resize', function () {
    setNumeronostoWidths();
});
